import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import app from './config';

export const REGION = 'europe-west1';

// getFunctions(app, region) liefert pro App+Region IMMER dieselbe Instanz (das SDK
// cacht sie im Component-Container). Ein einziger connect hier erreicht deshalb alle
// ~63 getFunctions(app, 'europe-west1')-Aufrufstellen im Projekt — sie müssen nicht
// angefasst werden. (CLAUDE.md nahm bis v3.107.0 das Gegenteil an und ließ den
// Functions-Emulator deswegen unverdrahtet.)
//
// Damit das greift, bevor irgendein Modul auf Modulebene getFunctions aufruft, wird
// diese Datei in src/index.js als erster Import geladen.
const functions = getFunctions(app, REGION);

// Opt-in, nur wenn explizit gesetzt (z.B. `REACT_APP_USE_EMULATORS=true npm start`) -
// Standardverhalten (Produktion) bleibt unverändert. Siehe docs/firebase-setup.md.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export default functions;
